import {createMatcherFunction} from '@/helpers/createMatcher'
import {TRANSACTION_CONTENT_ENUM, TRANSACTION_TYPE_ENUM} from '@/types/enums'

export const TransactionType = {
  [TRANSACTION_TYPE_ENUM.ALL]: 'All',
  [TRANSACTION_TYPE_ENUM.WITHDRAW]: 'Withdraw',
  [TRANSACTION_TYPE_ENUM.DEPOSIT]: 'Deposit',
  [TRANSACTION_TYPE_ENUM.BUY]: 'Buy',
  [TRANSACTION_TYPE_ENUM.SELL]: 'Sell',
}

export const getTransactionType = createMatcherFunction(TransactionType)

export const TransactionContent = {
  [TRANSACTION_TYPE_ENUM.ALL]: 'All',
  [TRANSACTION_CONTENT_ENUM.FEE]: 'Fee',
  [TRANSACTION_CONTENT_ENUM.ADVISOR]: 'Advisor',
  [TRANSACTION_CONTENT_ENUM.COIN]: 'Coin',
  [TRANSACTION_CONTENT_ENUM.RESOURCE]: 'Resource',
  [TRANSACTION_CONTENT_ENUM.OBJECT]: 'Object',
  [TRANSACTION_CONTENT_ENUM.SYSTEM_OBJ]: 'System object',
}

export const getTransactionContent = createMatcherFunction(TransactionContent)
